import React, { FC, ReactNode, useMemo } from 'react'
import { Icon } from '@iconify/react'
import { useTimeout } from 'usehooks-ts'
import S from './styles'

interface AlertProps {
  severity: 'error' | 'warning' | 'info' | 'success'
  children: ReactNode
  onClose: () => void
}

const Alert: FC<AlertProps> = ({ severity, children, onClose }) => {
  useTimeout(onClose, 10000)

  const icon = useMemo(() => {
    switch (severity) {
      case 'error':
        return 'bi:exclamation-circle-fill'
      case 'warning':
        return 'bi:exclamation-triangle-fill'
      case 'info':
        return 'bi:info-circle-fill'
      case 'success':
        return 'bi:check-circle-fill'
      default:
        return ''
    }
  }, [severity])

  return (
    <S.Alert className={severity} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
      <div>
        <Icon className="icon" icon={icon} fontSize={20} />
        {children}
      </div>
      <button type="button" aria-label="alert_close" onClick={onClose}>
        <Icon icon="bi:x" fontSize={20} />
      </button>
    </S.Alert>
  )
}

export default Alert
